export const LOCAL_STORAGE_THEME_KEY = 'theme';
export const LOCAL_STORAGE_LANGUAGE_KEY = 'htlgt-language';
